import { useCallback, useEffect, useState } from 'react';
import api from '../../services/api';
import { emitToast } from '../../context/toast';

export default function AdminTrainingPendingPanel() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionId, setActionId] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get('/training/admin/pending-clients');
      setRows(r.data?.data || []);
    } catch {
      emitToast({
        type: 'error',
        title: 'Error',
        message: 'Error cargando pendientes Training',
      });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const reject = async (userId) => {
    if (!window.confirm('¿Rechazar este cliente?')) return;
    setActionId(userId);
    try {
      await api.post(`/training/admin/clients/${userId}/reject`);
      emitToast({
        type: 'success',
        title: 'Rechazado',
        message: 'Cliente rechazado',
      });
      await load();
    } catch (e) {
      emitToast({
        type: 'error',
        title: 'Error',
        message: e.response?.data?.error || 'Error',
      });
    } finally {
      setActionId(null);
    }
  };

  return (
    <div className="card max-w-5xl mx-auto p-5 space-y-4">
      <div>
        <h2 className="text-xl font-bold text-stone-900">Clientes Training pendientes</h2>
        <p className="text-sm text-stone-600 mt-1">
          La vigencia la aplica el pago del plan (mensual, bimestral o trimestral). Este botón no suma días.
        </p>
      </div>

      {loading ? <p className="text-sm text-stone-500">Cargando…</p> : null}
      {!loading && !rows.length ? (
        <p className="text-sm text-stone-600">No hay clientes pendientes.</p>
      ) : null}

      {rows.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left border-b border-stone-200 text-stone-500">
                <th className="py-2 pr-3">Cliente</th>
                <th className="py-2 pr-3">Entrenador</th>
                <th className="py-2 pr-3">Estado</th>
                <th className="py-2">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.user_id} className="border-b border-stone-100">
                  <td className="py-3 pr-3">
                    <div className="font-medium text-stone-900">{row.usuario_nombre}</div>
                    <div className="text-xs text-stone-500">{row.usuario_email}</div>
                  </td>
                  <td className="py-3 pr-3">{row.entrenador}</td>
                  <td className="py-3 pr-3"><span className="badge-warning">{row.estado}</span></td>
                  <td className="py-3">
                    <div className="flex flex-wrap gap-2">
                      <span className="text-xs text-stone-500">Pago del plan</span>
                      <button
                        type="button"
                        className="btn-secondary text-xs py-1 px-2"
                        disabled={actionId === row.user_id}
                        onClick={() => activate(row.user_id, true)}
                      >
                        Activar + FOOD
                      </button>
                      <button
                        type="button"
                        className="btn-secondary text-xs py-1 px-2 text-red-700"
                        disabled={actionId === row.user_id}
                        onClick={() => reject(row.user_id)}
                      >
                        Rechazar
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
